const navHeadings = [
  {
    name: 'online',
    text: 'Online Campus',
  },
  {
    name: 'campus',
    text: 'Clearwater Campus',
  },
  {
    name: 'admissions',
    text: 'Admissions',
  },
  {
    name: 'employerPartners',
    text: 'Employer Partners',
  },
  {
    name: 'aboutUs',
    text: 'About Us',
  },
]

export default navHeadings
